import styled from "styled-components";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import FormSelectWithLabel from "../../../../../components/FormControls/FormSelectWithLabel";
import FormDatePicker from "../../../../../components/FormControls/FormDatePicker";
import FormCheckBoxWithRightLabel from "../../../../../components/FormControls/FormCheckBoxWithRightLabel"
import { useState, useEffect } from "react";
import React from "react";
import request from "../../../../../api/request";
import NotificationManager from "react-notifications/lib/NotificationManager";

const FadeBackground = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10000;
    left: 0;
    top: 0;
    background-color: #32323233;
`;

const StyledBankAccountBalances = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    box-sizing: border-box;
    width: 400px;
    height: 380px;
    border-radius: 5px;
    margin: auto;
    padding: 30px;
    font-size: 12px;
    font-weight: 600;
    z-index: 9999;
`;

const ModalTitle = styled.span`
    color: ${(props) => props.theme.color.dark};
    font-weight: 600;
    font-size: 20px;
`;

function BankAccountBalances(props) {

    const [downloadDate, setDownloadDate] = useState(new Date());
    const [regionName, setRegionName] = useState('All Regions')
    const [isDownloading, setIsDownloading] = useState(false);

    const [loadedPage, setLoadedPage] = useState(false);
    const [regionList, setRegionList] = useState([]);
    const [regionNameList, setRegionNameList] = useState([]);
    const [showReconciled, setShowReconciled] = useState(0);
    const [needsValidation, setNeedsValidation] = useState(false);

    const handleClickFadeBackground = (e) => {
        if (props.handleClickNo) {
            props.handleClickNo();
        }
        e.stopPropagation();
        e.preventDefault();
    }

    const dateToStr = (date) => {
        const month = date.toLocaleString('default', { month: 'long' });

        function pad(s) { return (s < 10) ? '0' + s : s; };
        let ret = [pad(date.getDate()), month, date.getFullYear()].join(' ');
        return ret;
    }

    const reconciledStringToNum = (str) => {
        if (str === 'Unreconciled balances') return 1;
        else return 0;
    }

    const reconciledNumToString = (num) => {
        if (num === 1) return 'Unreconciled balances';
        else return 'Reconciled balances';
    }

    const onClickDownload = async () => {
        if (!downloadDate) {
            setNeedsValidation(true);
        } else {
            setIsDownloading(true);

            let details = {};
            
            details.Date = downloadDate;
            details.RegionCode = regionNameToRegionCode(regionName);
            details.BalanceType = showReconciled;
            const resp = (await request('database', 'downloadBankAccountBalances', [details]));
            if (resp.ok) {
                let fileName = `Bank Account Balances as at ${dateToStr(downloadDate)}.xlsx`;
                var fileDownload = require('js-file-download');
                fileDownload(resp.data, fileName);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDownloading(false);
        }
    }
    
    const fetchRegions = async () => {
        try {
            let regions = [];
            let regionNames = [];

            const resp = (await request('database', 'fetchRegions'));
            if (resp.ok) {
                resp.data.map((item, index) => {
                    regions.push(item);
                    regionNames.push(item.RegionName);
                });
                setRegionList(regions);
                setRegionNameList(regionNames);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch regions: ', e);
            return false;
        }
        return true;
    }

    const regionNameToRegionCode = (rName) => {
        let ret = null;
        if (rName === 'All Regions') {
            return null;
        }

        regionList.map((r) => {
            if (r.RegionName === rName) {
                ret = r.RegionCode;
            }
        });

        return ret;
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchRegions();
            setLoadedPage();
        }
    }, []);

    useEffect(() => {
        setNeedsValidation(false);
    }, [downloadDate]);

    return (
        <FadeBackground onClick={handleClickFadeBackground}>
            <StyledBankAccountBalances onClick={(e) => {e.stopPropagation(); e.preventDefault()}} {...props}>
                <ModalTitle>Bank account balances report</ModalTitle>
                <FormDatePicker label='Download branch summary as at' value={downloadDate} onChange={(val) => setDownloadDate(val)} style={{width:340, marginTop:15}} validated={needsValidation && downloadDate === null ? false : undefined}></FormDatePicker>
                <FormSelectWithLabel label='Show' items={['Reconciled balances', 'Unreconciled balances']} value={reconciledNumToString(showReconciled)} onChange={(e) => setShowReconciled(reconciledStringToNum(e.target.value))} style={{width:340, height:35, paddingLeft:10}}></FormSelectWithLabel>
                <FormSelectWithLabel label='Region' items={['All Regions', ...regionNameList]} value={regionName} onChange={(e) => setRegionName(e.target.value)} style={{width:340, height:35, paddingLeft:10}}></FormSelectWithLabel>
                <div style={{display:'flex', marginTop:30}}>
                    <SecondaryButton caption='Cancel' onClick={() => props.handleClickNo ? props.handleClickNo() : {}} style={{width:126, height:35}}></SecondaryButton>
                    <PrimaryButton caption='Download to Excel' isLoading={isDownloading} onClick={() => onClickDownload()} style={{width:150, height:35, marginLeft:'auto'}}></PrimaryButton>
                </div>
            </StyledBankAccountBalances>
        </FadeBackground>
    );
}

export default BankAccountBalances;